/**
 *
 * Asynchronously loads the component for DateSelectionFilter
 *
 */
import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
